//@ts-check
import React from 'react';
import usePublicLinkFetch from './usePublicLinkFetch';
import PublicLinkContext from './PublicLinkContext';
import getPublicId from './getPublicId';
/**
 * @param {import('./types').PublicLinkProviderProps} props
 */

var PublicLinkProvider = function PublicLinkProvider(_ref) {
  var children = _ref.children,
      publicLinks = _ref.publicLinks,
      history = _ref.history;
  if (!history) return children;
  if (!history.location) return children;
  var publicId = getPublicId(history.location, publicLinks);
  if (!publicId) return children;
  return React.createElement(PublicLinkFetchProvider, {
    publicId: publicId
  }, children);
};

var PublicLinkFetchProvider = function PublicLinkFetchProvider(_ref2) {
  var children = _ref2.children,
      publicId = _ref2.publicId;
  var state = usePublicLinkFetch(publicId);
  return React.createElement(PublicLinkContext.Provider, {
    value: state
  }, children);
};

export default PublicLinkProvider;